import { createContext } from 'react'
const ActionCableContext = createContext()
export default ActionCableContext